import React from "react";

import { Wallet, Zap, ShieldCheck, MapPin, Users } from "lucide-react";

import "./Taisao.css";

const Taisao = () => {
  const benefits = [
    {
      icon: Wallet,
      title: "Phí thấp nhất chỉ từ 1,1%",
      description: "Cam kết mức phí tốt nhất thị trường",
    },
    {
      icon: Zap,
      title: "Nhận tiền siêu nhanh sau 5 phút",
      description: "Xử lý nhanh gọn, không mất thời gian",
    },
    {
      icon: ShieldCheck,
      title: "An toàn - Bảo mật",
      description: "Không giữ thẻ, không lưu thông tin, bảo mật tuyệt đối",
    },
    {
      icon: MapPin,
      title: "Hỗ trợ tận nơi 24/7",
      description: "Có mặt tại nhà, văn phòng, khắp các quận huyện",
    },
    {
      icon: Users,
      title: "Uy tín - Chuyên nghiệp",
      description: "Đội ngũ giàu kinh nghiệm, hỗ trợ nhiệt tình",
    },
  ];

  return (
    <section className="why-section">
      <div className="why-container">
        {/* SECTION HEADER */}

        <div className="why-heading">
          <h2>VÌ SAO NÊN CHỌN CHÚNG TÔI?</h2>

          <p>Hơn 10.000 khách hàng đã tin tưởng và sử dụng dịch vụ</p>
        </div>

        {/* BENEFITS GRID */}

        <div className="why-grid">
          {benefits.map((item, index) => {
            const Icon = item.icon;

            return (
              <div className="why-card" key={index}>
                {/* ICON */}

                <div className="why-icon">
                  <Icon size={42} strokeWidth={2.5} />
                </div>

                {/* TITLE */}

                <h3 className="why-card-title">{item.title}</h3>

                {/* DESCRIPTION */}

                <p className="why-card-description">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Taisao;
